import React, { Fragment } from 'react'
import { FormTextArea, FormCheckbox } from '@myxplor/forms'
import { ShowHide } from '../../../../../ui/record-display'
import ParentSelect from './parent-select'

const CommonEnrolmentFields = props => {
  const { values, onChange, errors } = props
  return (
    <Fragment>
      <ParentSelect {...props} />
      {props.children && <fieldset>{props.children}</fieldset>}
      <ShowHide label="Additional enrolment information">
        <fieldset>
          <legend>Additional enrolment information</legend>
          <FormCheckbox
            name="enrolment_params.isChildInStateCare"
            label="Child is in state care"
            onChange={onChange}
            value={values.enrolment_params.isChildInStateCare}
          />

          <FormTextArea
            name="enrolment_params.lateSubmissionReason"
            label="Reason for late submission"
            onChange={onChange}
            value={values.enrolment_params.lateSubmissionReason}
            errors={errors.lateSubmissionReason}
            maxLength={1000}
            rows={2}
            compact
          />
        </fieldset>
      </ShowHide>
    </Fragment>
  )
}

export default CommonEnrolmentFields



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/create-enrolment/common-fields.js